import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import { buildProviders, Coerce } from '@kalidea/kaligraphi';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {
    MonthAndYear
} from 'src/app/_shared/components/shared-month-and-year-picker/shared-month-and-year-picker.component';

@Component({
    selector: 'app-shared-month-and-year-range',
    templateUrl: './shared-month-and-year-range.component.html',
    styleUrls: ['./shared-month-and-year-range.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedMonthAndYearRangeComponent),
    standalone: false
})
export class SharedMonthAndYearRangeComponent extends CustomFormControlAccess implements OnInit {

    form: UntypedFormGroup;

    @Coerce('boolean')
    @Input()
    displayMonthYearEnd = false;

    @Input() startMonthYearLabel = '';

    @Input() endMonthYearLabel = '';

    private rangeErrorsMessages: Record<string, string> = {
        invalidmonthrange: 'La plage de mois sélectionnée n\'est pas valide.',
        invalidyearrange: 'La plage d\'années sélectionnée n\'est pas valide.'
    };

    constructor(private readonly fb: UntypedFormBuilder) {
        super();
    }

    validate(c: AbstractControl): Observable<ValidationErrors> {
        return of(this.form.valid ? null : {monthandyearrange: true});
    }

    writeValue(value: {startMonthYear: MonthAndYear, endMonthYear: MonthAndYear}): void {
        this.form.patchValue({
            startMonthYear: value?.startMonthYear || null,
            endMonthYear: value?.endMonthYear || null
        }, {emitEvent: false});

        if (this.form.value.endMonthYear && !this.displayMonthYearEnd) {
            this.toggleMonthYearEnd();
        }

        super.writeValue(value);
    }

    toggleMonthYearEnd(): void {
        this.displayMonthYearEnd = !this.displayMonthYearEnd;
    }

    getErrorMessages(errorObject: ValidationErrors): string[] {
        return Object.keys(errorObject).map(e => this.rangeErrorsMessages[e]);
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            startMonthYear: [null],
            endMonthYear: [null]
        }, {
            validators: [
                form => {
                    if(['startMonthYear', 'endMonthYear'].every(n => form.get(n).valid && !!form.get(n).value)) {
                        const {month: startMonth,  year: startYear} = form.value.startMonthYear;
                        const {month: endMonth, year: endYear} = form.value.endMonthYear;
                        if (startMonth === endMonth &&  startYear > endYear) {
                            return {invalidmonth: true};
                        }
                        if (startYear === endYear && startMonth > endMonth) {
                            return {invalidyear: true};
                        }
                    }
                    return null;
                }
            ]
        });

        this.watch$ = this.form.valueChanges.pipe(
            distinctUntilChanged(),
            tap(value => this.notifyUpdate(value))
        );
    }

}
